// src/icons.js
import {
  mdiClose,
  mdiBug,
  mdiCashMultiple,
  mdiHelpCircle,
  mdiCog,
  mdiLogin,
  mdiChevronDown,
  mdiChevronRight,
  mdiDelete,
  mdiNotePlus,
  mdiFileExcel,
  mdiTuneVariant,
  mdiThermometer,
  mdiChartAreaspline,
  mdiRepeat,
  mdiHistory,
  mdiCheckCircleOutline,
  mdiCancel,
  mdiAlertCircleOutline,
  mdiRobot,
  mdiFormatListBulleted,
  mdiBookOpenVariant,
  mdiRunFast,
  mdiFileDocumentOutline,
  mdiContentSaveOutline,
  mdiNumeric,
  mdiTextBoxOutline,
  mdiDiceMultiple,
  mdiDotsVertical,
  mdiOpenInNew,
  mdiFileImport,
  mdiYoutube,
  mdiShieldCheck,
  mdiCloudOff,
  mdiLaptop,
  mdiAlertCircle,
} from '@mdi/js';

const mdiCommentSmile = 'M9,22A1,1 0 0,1 8,21V18H4A2,2 0 0,1 2,16V4C2,2.89 2.9,2 4,2H20A2,2 0 0,1 22,4V16A2,2 0 0,1 20,18H13.9L10.2,21.71C10,21.9 9.75,22 9.5,22V22H9M10,6A1.5,1.5 0 1,0 11.5,7.5A1.5,1.5 0 0,0 10,6M14,6A1.5,1.5 0 1,0 15.5,7.5A1.5,1.5 0 0,0 14,6M12,14A3,3 0 0,0 15,11H9A3,3 0 0,0 12,14Z';

const icons = {
  mdiClose,
  mdiBug,
  mdiCommentSmile,
  mdiCashMultiple,
  mdiHelpCircle,
  mdiCog,
  mdiLogin,
  mdiChevronDown,
  mdiChevronRight,
  mdiDelete,
  mdiNotePlus,
  mdiFileExcel,
  mdiTuneVariant,
  mdiThermometer,
  mdiChartAreaspline,
  mdiRepeat,
  mdiHistory,
  mdiCheckCircleOutline,
  mdiCancel,
  mdiAlertCircleOutline,
  mdiRobot,
  mdiFormatListBulleted,
  mdiBookOpenVariant,
  mdiRunFast,
  mdiFileDocumentOutline,
  mdiContentSaveOutline,
  mdiNumeric,
  mdiTextBoxOutline,
  mdiDiceMultiple,
  mdiDotsVertical,
  mdiOpenInNew,
  mdiFileImport,
  mdiYoutube,
  mdiShieldCheck,
  mdiCloudOff,
  mdiLaptop,
  mdiAlertCircle,
};

export default icons;
